module.exports = __webpack_public_path__ + "static/gadula-logo-ed9b0011f5fa084c2b5c5d944d199d08.png";